export const TypeIcon = (
  <svg className="size-4" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.9624 13V17.375C9.9624 19.7875 11.9249 21.75 14.3374 21.75C16.7499 21.75 18.7124 19.7875 18.7124 17.375V10.5C18.7124 5.6625 14.7999 1.75 9.9624 1.75C5.1249 1.75 1.2124 5.6625 1.2124 10.5V18C1.2124 22.1375 4.5749 25.5 8.7124 25.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
